module.exports = __webpack_public_path__ + "img/headerLogo.ab47dcf1.png";